import type { ReactNode } from 'react'
import { X } from 'lucide-react'
import { Dialog, DialogClose, DialogContent } from '@quebon/ui/components/dialog'

interface VideoDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  children: ReactNode
}

export function VideoDialog({ open, onOpenChange, children }: VideoDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        showCloseButton={false}
        className="w-full max-w-[960px] p-2 sm:max-w-[960px] bg-black border-0 ring-0"
      >
        <DialogClose
          aria-label="닫기"
          className="absolute top-4 right-4 z-10 flex w-10 h-10 lg:w-12 lg:h-12 items-center justify-center rounded-full bg-black/60 text-white shadow-lg backdrop-blur-sm hover:bg-black/80 transition-colors outline-none focus:outline-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70"
        >
          <X className="w-5 h-5 lg:w-6 lg:h-6" strokeWidth={2.25} />
        </DialogClose>
        <div className="w-full aspect-video lc-video-wrapper">{children}</div>
      </DialogContent>
    </Dialog>
  )
}
